import { css } from "@emotion/react";

import { responsiveBreakpoint } from "@constants";

export const footer = css`
  border-top: 1px solid var(--gray-100);
  background-color: var(--white);
  padding: 32px 16px;

  @media (min-width: ${responsiveBreakpoint[0]}px) {
    padding: 40px 16px 40px 16px;
  }
`;

export const centerBox = css`
  @media (min-width: ${responsiveBreakpoint[0]}px) {
    width: 100%;
    max-width: 1060px;
    margin: auto;
    position: relative;
  }
`;

export const topBox = css`
  border-bottom: 1px solid var(--gray-100);
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;

  @media (min-width: ${responsiveBreakpoint[0]}px) {
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 16px;
    padding-bottom: 32px;
  }
`;

export const pcPolicySNS = css`
  @media (min-width: ${responsiveBreakpoint[0]}px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }
`;

export const ismsBox = css`
  position: absolute;
  right: 0;
  bottom: 0px;
`;

export const mobileSNSIsmsDiv = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;
